export default class ParamModel {
  constructor () {
    this.command = null
    this.body = null
  }
}
